const to = promise => (
  promise
    .then(data => ({data, error: null}))
    .catch(error => ({error, data: null}))
)

export {
  to
}



//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/endpoints/utils.js
// module id = null
// module chunks = 